var ArtigoInteligencia = function () {
	
	this.article = function (item) {

		var html = "";
		html += '<div class="box-artigo row">';
		html += '<div class="col-xs-12 col-md-5">';
		html += '<img src="'+ item.Image + '" />';
		html += '</div>';
		html += '<div class="col-xs-12 col-md-7 artigo-inteligencia">';
		html += '<h4>'+ item.Name +'</h4>';
		html += '<p>' + item.ShortDescription +'</p>';
		html += '<a href="'+ item.Url+ '">Saiba Mais</a>';	
		html += '</div></div>';

		return html;
	}

    this.init = function () {
		var obj = this;

		$('.btn-more-inteligencia').click(function(e){
			e.preventDefault();

			$('.loader').show();

			var Component = $(this);
			var TabId = Component.data('tab');
			var Limiter = 3; //$(this).data("limiter");
			var TotalAmount = $("#artigo-inteligencia > DIV").length;
			
			$.ajax({
				type: "POST",
				url: " /umbraco/surface/services/loadmore",
				data: JSON.stringify({"ComponentID": TabId, "Limiter": Limiter , "TotalAmount": TotalAmount}),
				dataType: "json",
				async: true,
				contentType: "application/json; charset=utf-8",
				success: function success(response) {
					
					var html = '';
					if(response){

						for (var i = 0; i < response.services.length; i++) {
							html += obj.article(response.services[i]);
						}

						$('#artigo-inteligencia').append(html);
						
						TotalAmount = $("#artigo-inteligencia > DIV").length;
						if(TotalAmount >= response.serviceListTotalAmount){
							$('.btn-more-inteligencia').hide();
						}else{
							$('.btn-more-inteligencia').show();
						}

					}
					else{
						
					}
					
				},
				error: function error(e) {
					
				},
				complete: function () {
					$('.loader').hide();
				}
			});
		
		});
	}

	return this.init();
}